import { render, staticRenderFns } from "./PermissionControls.vue?vue&type=template&id=145f23aa&scoped=true"
import script from "./PermissionControls.vue?vue&type=script&lang=js"
export * from "./PermissionControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f23aa",
  null
  
)

export default component.exports